import { IGlobalState } from '../../Root/store/appReducer'
import { CompanyId, Role } from '../../services/api.types'

export const getUserDto = (state: IGlobalState) => state.auth.userDto
export const getUserCompanies = (state: IGlobalState) => state.auth.userCompanies
export const getManagedCompanies = (state: IGlobalState) => state.auth.managedCompanies
export const getUserCompanyRoles = (state: IGlobalState) => state.auth.userCompanyRoles
export const isAuthenticated = (state: IGlobalState) => state.auth.authenticated
export const isResetPasswordInProgress = (state: IGlobalState) => state.auth.resetPasswordInProgress
export const isEmailVerificationInProgress = (state: IGlobalState) => state.auth.emailVerificationInProgress
export const getUserIntegrationScopes = (state: IGlobalState) => state.auth.userIntegrationScopes

export const hasAnyRole = (state: IGlobalState, expectedRoles: Role[]) =>
  expectedRoles.some((expectedRole) => hasRole(state, expectedRole))

export const isSuperAdmin = (state: IGlobalState) => state.auth.isSuperAdmin

export const hasRole = (state: IGlobalState, expectedRole: Role) => {
  if (expectedRole === Role.AUTHENTICATED && state.auth.authenticated) {
    return true
  }
  if (!state.auth.userCompanyRoles || (!state.auth.userCompanyRoles.length && expectedRole === Role.ANONYMOUS)) {
    return true
  }
  if (expectedRole === Role.ADMIN && state.auth.isSuperAdmin) {
    return true
  }
  return state.auth.userCompanyRoles.some((companyRole) => companyRole.roles.some((role) => role === expectedRole))
}

export const hasRoleInCompany = (state: IGlobalState, companyId: CompanyId, expectedRole: Role) => {
  if (expectedRole === Role.ADMIN && state.auth.isSuperAdmin) {
    return true
  }
  if (!state.auth.userCompanyRoles || (!state.auth.userCompanyRoles.length && expectedRole === Role.ANONYMOUS)) {
    return true
  }
  return state.auth.userCompanyRoles.some(
    (companyRole) => companyRole.companyId === companyId && companyRole.roles.some((role) => role === expectedRole),
  )
}
